import gql from 'graphql-tag';

const MODIFY_PLANOGRAM_ITEM_PRICE = gql`
	mutation modifyPlanogramItem (
		$id: ID,
		$values: PlanogramItemInput,
	) {
		modifyPlanogramItem(
			id: $id,
			values: $values,
		) {
			id
			price
			queuedPrice
			queuedPriceType
		}
	}
`;

export default MODIFY_PLANOGRAM_ITEM_PRICE;

